import type { IconProps } from "../types";

/**
 * Droplets: registry 独自の「温泉マーク」アイコン。
 * lucide `Droplets` ではなく service-icon-registry.ts の custom svgContent を逐語再現。
 */
export const Droplets = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<path d="M7 20h10a1 1 0 0 0 1-1v-2a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v2a1 1 0 0 0 1 1ZM8.5 6c0-1 .5-2 2-3M12 6c0-1 .5-2 2-3M15.5 6c0-1 .5-2 2-3" />
	</svg>
);
